import { getPlayer, getTeam } from "../../utils.js";
import { isSecondYellowForPlayer } from "../../utils/cards.js";
import GameFactEventDto from "../GameFactEventDto.js";

const REASONS_LABEL = {
  faute: "Faute",
  contestation: "Contestation",
  simulation: "Simulation",
  gaintemps: "Gain de temps",
};

export class YellowCardDto extends GameFactEventDto {
  constructor(event) {
    super(event);
    this.tab = event.tab ?? "CARTON JAUNE";
    this.detail = {
      ...this.detail,
      title: event.detail?.title || "CARTON JAUNE",
      player: event.detail?.player,
      team: event.detail?.team,        // nécessaire au comptage
      reason: event.detail?.reason,
      text: event.detail?.text,
    };
  }

  get player() { return this.detail.player; }
  set player(value) { this.detail.player = value; }

  get team() { return this.detail.team; }
  set team(value) { this.detail.team = value; }

  get reason() { return this.detail.reason; }
  set reason(value) { this.detail.reason = value; }

  initTimerPeriod(match){ super.initTimerPeriod(match); }

  /**
   * @param {string} key
   * @param {any} value
   * @param {object} match
   * @param {Array} existingFacts  ← tableau des gamefacts déjà présents sur le match
   */
  updateDetail(key, value, match, existingFacts = []) {
    super.updateDetail(key, value);

    if (!this.isAutomaticCommentary) return;

    if (["isAutomaticCommentary", "team", "player", "reason"].includes(key)) {
      const team = getTeam(this.team, match);
      const playerObj = this.player ? getPlayer(this.player, match, team) : null;

      // détermine si ce sera un 2e jaune (donc rouge) - TODO notion de création, if GF id == null peut-être
      const secondYellow = isSecondYellowForPlayer(existingFacts, {
        teamId: this.team,
        playerId: this.player
      });

      // ----- titre & texte -----
      let title = secondYellow ? "CARTON ROUGE" : "CARTON JAUNE";

      let commentaire = secondYellow ? "Carton rouge" : "Carton jaune";
      if (playerObj?.lastname) {
        commentaire += ` pour ${playerObj.lastname}`;
      } else if (team?.name) {
        commentaire += ` pour ${team.name}`;
      }
      commentaire += "! ";

      if (this.reason && REASONS_LABEL[this.reason]) {
        commentaire += `Raison : ${REASONS_LABEL[this.reason]}.`;
      }

      // un 2e jaune → on peut être plus explicite
      if (secondYellow && playerObj?.lastname) {
        commentaire += ` Deuxième avertissement pour ${playerObj.lastname} : expulsion.`;
      }

      this.detail.title = title;
      this.text = commentaire;
    }
  }
}